import axios from 'axios'
import library from '../../../utils/Library'

export const getUserSessions = async (loginaccountID) => {
  const URL = library.getBaseAPIUrl('sessions') + `/reportUserActivityESessions/${loginaccountID}`
  return await axios.get(URL)
}
